/**
 * Claim page opened as a popup by the partner app: tell the opener which org was claimed
 * (only to the origin the partner registered with the link), then close. Returns false when
 * there is no opener (opened in a tab), so the caller navigates instead.
 */
export function notifyOpener(
    win: Pick<Window, 'opener' | 'close'>,
    orgId: string,
    returnOrigin: string,
): boolean {
    const opener = win.opener as Pick<Window, 'postMessage'> | null
    if (!opener || !returnOrigin) {
        return false
    }
    try {
        opener.postMessage({ type: 'yom:claimed', org_id: orgId }, returnOrigin)
    } catch {
        return false
    }
    win.close()
    return true
}
